exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-5e25763a] {\n\tmax-height: 180px;\n\tmax-width: 180px;\n\twidth: 180px;\n\tmargin-bottom: 0px;\n}\n#topPart[data-v-5e25763a] {\n\tmin-height: 15vh;\n}\n#middlePart[data-v-5e25763a] {\n\tmin-height: 70vh;\n}\n#bottomPart[data-v-5e25763a] {\n\tmin-height: 10vh;\n}\n#helpBtn[data-v-5e25763a] {\n\theight: 90vw;\n\twidth: 90vw;\n\tmax-height: 350px;\n\tmax-width: 350px;\n\tmargin: 0 auto;\n\tfont-size: 3em;\n\tborder-radius: 100%;\n}\n#cancelHelp[data-v-5e25763a] {\n\tfont-size: 2em;\n}\n\n", ""]);

// exports
